module.exports = __webpack_public_path__ + "static/media/hdfc_ergo_ic_logo_cta.8d10b5f4.svg";